import React from 'react';
import ViewContext, { clientView } from 'Context/ViewContext';
import Children from '../Sections/Children';
import Dependents from '../Sections/Dependents';
import FamilyDetails from '../Sections/FamilyDetails';
import Navigator from '../UI/Navigator';

const FamilyInformation = () => (
  <ViewContext.Consumer>
    {view => (
      <Navigator>
        <Children />
        {clientView === view ? <Dependents isLastSection /> : <Dependents />}
        <FamilyDetails />
      </Navigator>
    )}
  </ViewContext.Consumer>
);

export default FamilyInformation;
